import type { RecommendationLayoutSeed } from 'src/pages/Product/functions/recommendationLayoutSeed'
import type { GetStaticPaths, GetStaticProps } from 'next'
import type { ParsedUrlQuery } from 'querystring'

import { loadProductPageData } from 'src/functions/pageData'
import Product from 'src/pages/Product/index'
import { type tProduct } from 'src/shared/frontendTypes/product'
import type { MenuPageBuilder } from 'src/shared/dbTypes/menuPageBuilder'
import type { LandingPageProductInquirySettings } from 'src/shared/dbTypes/landingPageSettings'
import type { LandingPageImageAiGenerated } from 'src/functions/landingPageImageAiGenerated'

interface Params extends ParsedUrlQuery {
  pid: string
  alias: string
  variant: string
}

interface Props {
  product: tProduct
  recommendationsDeferred?: boolean
  recommendationsLayoutSeed?: RecommendationLayoutSeed
  initialVariantKey?: string
  sitePageBuilder?: MenuPageBuilder
  productInquiry?: LandingPageProductInquirySettings
  landingPageImageAiGenerated?: LandingPageImageAiGenerated
}

const ProductVariantPage: React.FC<Props> = ({ product, recommendationsDeferred, recommendationsLayoutSeed, initialVariantKey, landingPageImageAiGenerated }) => (
  <Product product={product} recommendationsDeferred={recommendationsDeferred} recommendationsLayoutSeed={recommendationsLayoutSeed} initialVariantKey={initialVariantKey} landingPageImageAiGenerated={landingPageImageAiGenerated} />
)

export default ProductVariantPage

// Variant pages use the same short ISR window as the base product page. Generate
// requested variants on demand instead of multiplying the full static export.
export const getStaticPaths: GetStaticPaths<Params> = async () => ({
  paths: [],
  fallback: process.env.BUILD ? false : 'blocking',
})

export const getStaticProps: GetStaticProps<Props, Params> = async ({ params }) => {
  const { pid, alias, variant } = params as Params
  return loadProductPageData({ pid, alias, variantKey: String(variant) })
}
